module.exports = __webpack_public_path__ + "img/niño53.4a476e69.jpg";